import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import StockDetailsDescription from "./StockDetailsDescription";
// import JobVacancyPost from "./JobVacancyPost";
import RightSideContent from "./RightSideContent";
import Section from "./Section";
import BidingDetails from "./BidingDetails";
import BidingDetailsCourier from "./BidingDetailsCourier";
import { getStockById } from "../../api/stock/getStockById.js";
import StockListPage from "./StockListPage.js";
import { getStockByVesselId } from "../../api/stock/getStockByVesselId.js";
import { getCofByVesselId } from "../../api/cof.js";
import { getItemData } from "../../api/Item/itemApi.js";
import { getVessel } from "../../api/VesselDetails/addVesselApi.js";
import boat from "../../assets/images/stock_details/boat.png";
import boat1 from "../../assets/images/stock_details/boat_1.png";
import boat2 from "../../assets/images/stock_details/boat_1.png";
import boat3 from "../../assets/images/stock_details/boat_1.png";
import { getBookmark } from "../../api/BookMarks/BookmarkApi.js";
import { getProcessingCostsByIdandType } from "../../api/processing plant/plantApi.js";
import OffCanvasPage from "../Vessels/VesselOffCanvas.js";
import PPOffCanvasPage from "../CandidateAndCompany/ProcessingPlant/ProcessingPlantOffCanvas";
import { getOrdersByVessel } from '../../api/order/orderApi.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon
import {
  faWallet,
  faCalendar,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons'; // Added calendar and location icons
import { format, parseISO } from 'date-fns';
import { Link } from 'react-router-dom';
const StockDetails = () => {
  // Updated component name
  const [stockData, setStockData] = useState([]);
  const [otherstockData, setOtherStockData] = useState([]);
  const [cofData, setCofData] = useState([]);
  const [itemData, setItemData] = useState([]);
  const [plantCost, setPlantCost] = useState([]);
  const [imageLarge, setImageLarge] = useState(null);
  const [imageSmall1, setImageSmall1] = useState(null);
  const [imageSmall2, setImageSmall2] = useState(null);
  const [imageSmall3, setImageSmall3] = useState(null);
  const [imageSmall4, setImageSmall4] = useState(null);
  const [offCanvas, setOffCanvas] = useState(false);
  const [pastOrders, setPastOrders] = useState(null);
  const [error, setError] = useState(null);

  const getIdFromUrl = (url) => {
    const urlParts = url.split('/');
    return urlParts[urlParts?.length - 1]; // Get the last part of the URL
  };

  const fetchStockData = async () => {
    const id = getIdFromUrl(window.location.pathname);
    try {
      const response = await getStockById(id);
      const data = response.data.data;
      //console.log(data);
      setStockData(data); // Set the stock data
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  };

  const fetchProcessingCost = async (plantId, type) => {
    console.log('plantId', plantId);
    console.log('type', type);
    try {
      const response = await getProcessingCostsByIdandType(plantId, type);
      const data = response.data;
      console.log('cost data', response);
      setPlantCost(data); // Set the stock data
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  };

  const fetchOtherStockDataOfVessel = async (Boat_Number) => {
    try {
      const response = await getStockByVesselId(Boat_Number);
      const data = response.data.data;
      //console.log(data);

      setOtherStockData(data); // Set the stock data
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  };

  const fetchCofByVesselId = async (Boat_Number) => {
    try {
      const response = await getCofByVesselId(Boat_Number);
      const data = response.data;
      console.log(data.status);
      setCofData(data); // Set the stock data
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  };

  const fetchItems = async (Trip_Number, Stock_id) => {
    try {
      const response = await getItemData(Trip_Number, Stock_id);
      const data = response.data;
      console.log(data.fish);
      setItemData(data.fish); // Set the stock data
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  };

  useEffect(() => {
    fetchStockData();
  }, []); // Fetch stock data on component mount

  useEffect(() => {
    if (stockData?.Boat_Number) {
      // fetchVesselImages(stockData.Boat_Number);
      // fetchOtherStockDataOfVessel(stockData.Boat_Number);
      // fetchCofByVesselId(stockData.Boat_Number);
      fetchPastOrders(stockData.Boat_Number); // Fetch past orders
    }
  }, [stockData]);

  useEffect(() => {
    if (stockData?.Boat_Number) {
      const getV = async (vessel) => {
        const response1 = await getVessel(vessel);
        const vessel1 = response1.data;
        setImageLarge(vessel1.Image_Large);
        setImageSmall1(vessel1.Image_Small1);
        setImageSmall2(vessel1.Image_Small2);
        setImageSmall3(vessel1.Image_Small3);
        setImageSmall4(vessel1.Image_Small4);
        console.log('TICK DFSFSDFSDFSF', response1);
      };

      getV(stockData?.Boat_Number);
      fetchOtherStockDataOfVessel(stockData.Boat_Number); // Fetch other stock data once stockData.Boat_Number is available
    }
  }, [stockData]);

  useEffect(() => {
    if (stockData?.Boat_Number) {
      fetchCofByVesselId(stockData.Boat_Number); // Fetch other stock data once stockData.Boat_Number is available
    }
  }, [stockData]);

  useEffect(() => {
    if (stockData?.Trip_Number && stockData?.Stock_id) {
      fetchItems(stockData.Trip_Number, stockData.Stock_id); // Fetch other stock data once stockData.Boat_Number is available
    }
  }, [stockData]);

  useEffect(() => {
    if (stockData?.Processing_Plant_Id && stockData?.Stock_id) {
      fetchProcessingCost(stockData.Processing_Plant_Id, stockData.Stock_id); // Fetch other stock data once stockData.Boat_Number is available
    }
  }, [stockData]);
  const showOffCanvas1 = () => {
    setOffCanvas(!offCanvas);
  };
  document.title = 'Stock Details | StarMarket';

  const fetchPastOrders = async (boatNumber) => {
    try {
      const response = await getOrdersByVessel(boatNumber);
      console.log('Past Orders Response:', response);
      setPastOrders(response.data.data || []); // Assuming response.data.orders is the array of orders
    } catch (error) {
      console.error('Error fetching past orders:', error);
      setError('Failed to fetch past orders.');
    }
  };

  return (
    <React.Fragment>
      <section
        className="section gaps bg-light"
        style={{
          paddingTop: '80px',
        }}
      >
        <Container
          fluid
          className="gaps"
        >
          <Section link="Stock Details" />
          <Link
            style={{ marginTop: '20px !important', backgroundColor: '#1E40AF' }}
            to="/stocks"
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-white bg-blue-900 border border-transparent rounded-md shadow-sm hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mb-2"
          >
            ← Back to Stocks
          </Link>
          <Row>
            <Row className="g-3 align-items-stretch">
              {/* Left Column */}
              <Col
                md={6}
                className="d-flex flex-column"
              >
                <div className="d-flex flex-column h-100">
                  <img
                    src={imageLarge || boat}
                    style={{ borderRadius: '20px' }}
                    alt=""
                    className="img-fluid w-100 h-100 object-fit-cover"
                  />
                </div>
              </Col>

              {/* Right Column */}
              <Col
                md={6}
                className="d-flex flex-column"
              >
                <Row className="g-3 h-100">
                  <Col
                    xs={6}
                    md={6}
                  >
                    <img
                      src={imageSmall1 || boat1}
                      style={{ borderRadius: '20px' }}
                      alt=""
                      className="img-fluid w-100 h-100 object-fit-cover"
                    />
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                  >
                    <img
                      src={imageSmall2 || boat2}
                      style={{ borderRadius: '20px' }}
                      alt=""
                      className="img-fluid w-100 h-100 object-fit-cover"
                    />
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                  >
                    <img
                      src={imageSmall3 || boat3}
                      style={{ borderRadius: '20px' }}
                      alt=""
                      className="img-fluid w-100 h-100 object-fit-cover"
                    />
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                  >
                    <img
                      src={imageSmall4 || boat2}
                      style={{ borderRadius: '20px' }}
                      alt=""
                      className="img-fluid w-100 h-100 object-fit-cover"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ marginTop: '40px' }}>
              <Col md={8}>
                <StockDetailsDescription
                  stockData={stockData}
                  CofData={cofData}
                  ItemData={itemData}
                  processingCost={plantCost}
                  showOffCanvas={showOffCanvas1}
                />

                <br />
                <br />
              </Col>
              <Col
                md={4}
                className="mt-4 mt-lg-0"
              >
                <RightSideContent
                  stockData={stockData}
                  processingCost={plantCost}
                />
              </Col>
            </Row>
            <Row>
              <Col
                md={4}
                className="mt-4 mt-lg-0"
              >
                <h5 className="mb-3">Past Orders of the Seller</h5>

                <div className="orders-section">
                  {pastOrders ? (
                    // pastOrders.map((order, index) => (
                    <div
                      // key={index}
                      className="order-item"
                    >
                      <div className="d-flex">
                        <img
                          src={pastOrders.image || boat} // Fallback to boat image if order.image is missing
                          alt="Order"
                          className="order-image"
                        />
                        <div>
                          <p>
                            <strong>
                              {pastOrders.Product_Name || 'Unknown Item'}
                            </strong>
                          </p>
                          <p className="mb-0">
                            <FontAwesomeIcon
                              icon={faCalendar}
                              className="mr-1"
                              style={{ color: '#6c757d', marginRight: '10px' }} // Gray color
                            />

                            {pastOrders.Created_At
                              ? format(
                                  parseISO(pastOrders.Created_At),
                                  'dd/MM/yyyy'
                                )
                              : 'N/A'}
                            <FontAwesomeIcon
                              icon={faMapMarkerAlt}
                              className="mr-5"
                              style={{
                                color: '#6c757d',
                                marginRight: '10px',
                                marginLeft: '10px',
                              }} // Gray color
                            />
                            {pastOrders.Harbour || 'N/A'}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex mt-4 ml-1">
                        <p
                          style={{ padding: '0px 20px 0px 0px' }}
                          className="mr-4"
                        >
                          <FontAwesomeIcon
                            icon={faWallet}
                            className="mr-1"
                            style={{
                              fontSize: '18px',
                              color: 'gray',
                              marginRight: '10px',
                            }} // Green color for wallet icon
                          />
                          LKR {pastOrders.Price_per_Kg || 'N/A'}
                        </p>
                        <span
                          style={{
                            margin: '0 10px',
                            display: 'inline-block',
                            width: '2px',
                            height: '26px',
                            backgroundColor: '#ccc',
                            verticalAlign: 'middle',
                          }}
                        />
                        <span
                          style={{ padding: '3px 25px' }}
                          className="status-button-warning"
                          size="sm"
                        >
                          {pastOrders.Status || 'Unknown'}
                        </span>
                      </div>
                    </div>
                  ) : (
                    // ))
                    <p>No orders available</p>
                  )}
                </div>
              </Col>
            </Row>
          </Row>
        </Container>
      </section>
      {offCanvas && (
        <OffCanvasPage
          isOpen1={offCanvas}
          vesselNumber={stockData.Boat_Number}
          isOpenFunction={showOffCanvas1}
        />
      )}
    </React.Fragment>
  );
};

export default StockDetails; // Updated export name
